const initialState = {
  values: {
    agencies: [],
  },
  errors: {},
  validations: {},
  saving: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CAMPAIGN_SAVING':
      return { ...state, saving: action.payload };
    case 'CLEAR_ERRORS':
      return { ...state, errors: {} };
    case 'ADD_CAMPAIGN_ERROR': {
      const errors = { ...state.errors, [action.id]: action.message || true };
      return { ...state, errors };
    }
    case 'EDIT_ADD_CAMPAIGN': {
      let values;
      let validations;

      if (action.id === 'agencies') {
        if (action.checked) {
          values = {
            ...state.values,
            agencies: [...state.values.agencies, Number(action.agencyId)],
          };
          validations = { ...state.validations, agencies: action.valid };
        } else {
          values = {
            ...state.values,
            agencies: [
              ...state.values.agencies.filter((agency) => agency !== Number(action.agencyId)),
            ],
          };
          validations = { ...state.validations, agencies: action.valid };
        }
      } else {
        values = { ...state.values, [action.id]: action.value };
        validations = { ...state.validations, [action.id]: action.valid };
      }

      return { ...state, values, validations };
    }
    case 'CLEAR_ADD_CAMPAIGN':
      return { ...initialState };
    default:
      return state;
  }
};
